export default "__VITE_ASSET__8060e95c__"